import { useQuery } from "@tanstack/react-query";
import React from "react";
import Loader from "./Loader/Loader";
import PageFilterContainer from "./PageFilterContainer";
import { BASEURL, HEADERS } from "./Utils/Constants";

const PageFilterContainerLoadDimensions = ({
  dimensions = [],
  parentProps,
}) => {
  const {
    data = [],
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["pageFilterContainer", { dimensions: dimensions.join(",") }],
    queryFn: () =>
      fetch(BASEURL + "/query-builder/metadata/dimensions", {
        method: "POST",
        headers: HEADERS(window.localStorage.token),
        body: JSON.stringify({
          dimensionIds: dimensions,
        }),
      })
        .then((response) => response.json())
        .then((result) => result),
    refetchOnWindowFocus: false,
    retry: false,
  });

  if (isError) {
    return (
      <div className="col-2">
        <small>Error loading filters</small>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="col-2">
        <Loader minHeight={100} size="circle-scale--sm  " />
      </div>
    );
  }

  // to keep the same order of dimensions
  const mappedDimensions = dimensions.map((dimensionId) =>
    data.find((d) => d.id === dimensionId)
  );

  return mappedDimensions.map((dimension, key) => (
    <PageFilterContainer key={key} {...{ ...parentProps, dimension }} />
  ));
};

export default PageFilterContainerLoadDimensions;
